/**
 * @deprecated
 */
import $ from 'jquery';

require('./web/jquery.webslider');
// var $ = require('jquery');
//shimované pluginy většinou nemají export, většinou extendují jQuery object
require('./web/jquery.touchSwipe');
require('./web/ramjet/liveValidation');
require('./web/ramjet/partialUpdate');
// var TargetBlankAutoTitle = require('fg-frontend/plugins/required/targetBlankAutoTitle');
// require('./web/jquery.cookies-policy');
require('./web/jquery.googlemap');
require('./web/jquery.googlemap.conf');
require('./web/jquery.beton-slider');
require('./web/jquery.socialshare');
require('./web/highslide-settings');
// require('./web/collapse');
require('./web/jquery.universalPagination');
require('./web/jquery.disableChars');
require('./web/jquery.slick');
require('./web/jquery.unveil');
require('./web/jquery.inspiration.favorites');

//require('jquery-ui/datepicker');
//require('jquery-ui/i18n/datepicker-cs');
//require('fg-frontend/third/jquery-ui/datetimePicker/timepicker');
//require('fg-frontend/third/jquery-ui/datetimePicker/localization/timepicker-cs');

//export to window
window.$ = $;
window.jQuery = $;

/*
 * Pokud máte na stránce anchor s target="blank" atributem, který nemá vyplněný title, nasadí se na něj
 * automaticky titulek ve smyslu "Otevře se v novém okně" dle langu stránky (atribut html lang).
 * Texty jsou definované ve třídě TargetBlankAutoTitle. Lze je definovat ručně při incicalizaci
 * např:  $("body").targetBlankAutoTitle({labels: {cs: "Lorem ipsum", sk: "Dolor sit"}});
 *
 * Pro weby mimo standardní kolekci jazyků (en, de, sk, cz) doporučuji překlad korekturovat.
 * Byl pouze automaticky přeložen.
 *
 * Korekturované překlady můžete dávat do issue https://ep.fg.cz/issues/60227
 *
 * Zkratky jazyků jsou z ISO 639-1 normy
 */
// window.targetBlankAutoTitle = new TargetBlankAutoTitle();

/**
 * JS oznámení o použití cookies na webu
 * default nastavení - viz: fg-frontend/plugins/required/jquery.cookies-policy
 *
 * * možnost redefinovat si styly přidáním parametru přes parametr css, případně je barvu tlačítka a odkazu: css.brandColor
 * * position - určuje vložení do požadovaného elementu na začátek (position: 'top') nebo na konec (position: 'bottom'),
 * * možnost definovat si vlastní textaci přes parametr messages.lang: (defaulty jsou v CS, SK, EN, DE, RU, ES)
 */

jQuery.cookie=function(e,i,o){if("undefined"==typeof i){var n=null;if(document.cookie&&""!=document.cookie)for(var r=document.cookie.split(";"),t=0;t<r.length;t++){var p=jQuery.trim(r[t]);if(p.substring(0,e.length+1)==e+"="){n=decodeURIComponent(p.substring(e.length+1));break}}return n}o=o||{},null===i&&(i="",o.expires=-1);var u="";if(o.expires&&("number"==typeof o.expires||o.expires.toUTCString)){var s;"number"==typeof o.expires?(s=new Date,s.setTime(s.getTime()+24*o.expires*60*60*1e3)):s=o.expires,u="; expires="+s.toUTCString()}var a=o.path?"; path="+o.path:"",c=o.domain?"; domain="+o.domain:"",m=o.secure?"; secure":"";document.cookie=[e,"=",encodeURIComponent(i),u,a,c,m].join("")};
function setCookie(cookieName, cookieValue, cookieExpirationDays) {
  if (cookieExpirationDays) {
    $.cookie(cookieName, cookieValue, { expires: cookieExpirationDays, path: '/', secure: true });
  } else {
    $.cookie(cookieName, cookieValue, { path: '/', secure: true });
  }
}
window.setCookie = setCookie;

function delCookie(cookieName) { $.cookie(cookieName, null, { path: '/' }); }
window.delCookie = delCookie;

function getCookie(cookieName) { return $.cookie(cookieName); }
window.getCookie = getCookie;



Array.max = function( array ){
  return Math.max.apply( Math, array );
};

var campaign = function() {
  let cookieExpirationDays = 7;
  var init = function() {
    $('.js_campaignClose').on('click', function () {
      setCookies();
      $('.campaign-bar').hide();
    });
    showBar();
  };

  var setCookies = function() {
    if (!getCookie('fgCampaignCount')) {
      setCookie('fgCampaignCount', 1, cookieExpirationDays);
    } else {
      let count = parseInt(getCookie('fgCampaignCount')) + 1;
      setCookie('fgCampaignCount', count, cookieExpirationDays);
    };

    if (parseInt(getCookie('fgCampaignCount')) >= 2) {
      setCookie('fgCampaign', true, cookieExpirationDays);
    }
  };

  var showBar = function() {
    if (!getCookie('fgCampaign')) {
      $('.campaign-bar').show();
    };
  };

  init();
};

var campaignPage = function() {
  let cookieExpirationDays = 7;
  var init = function() {
    setCookie('fgCampaign', true, cookieExpirationDays);
  };

  init();
};

$(function() {

  $(document).on('click', '.accordion .accordionTop', function() {
    $(this).next('.accordionBottom').slideToggle(400, function() {
      $('.sameColsHeight', this).each(function() {
        sameColsHeight();
      });
    });
    $(this).parent().toggleClass('active');
  });

  $('body').on('click', '.js_toggleCloseClass', function(e){
    $(this).toggleClass('close');
    $('body').toggleClass('responsiveMenuVisible');
    e.preventDefault();
    $('.responsiveMenuVisible .navbar-custom-collapse').each(function() {
      var headerHeight = $('header').outerHeight(false);
      $(this).css({'min-height' : headerHeight + 'px'});
    });
  });

  $(document).on('click', '.hasChildren > span', function() {
    $(this).parent().toggleClass('active');
  });

  var infoBoxTimeout;
  $(document).on('mouseenter', '.infoMark', function() {
    var parent = $(this).parent();
    $('.infoBox').hide();
    clearTimeout(infoBoxTimeout);
    $('.infoBox', parent).fadeIn();
  });

  $(document).on('mouseout', '.infoMark', function() {
    var parent = $(this).parent();
    infoBoxTimeout = setTimeout(function() {
      $('.infoBox', parent).fadeOut();
      clearTimeout(infoBoxTimeout);
    }, 1500);
  });

  var pictogramInfoBoxTimeout;
  $(document).on('mouseenter', '.pictogramInfoMark', function() {
    var parent = $(this).parent();
    $('.pictogramInfoBox').hide();
    var pictogramInfoMarkLeftPos = $(this).position().left - 42;
    var pictogramInfoMarkTopPos = $(this).position().top + 42;
    clearTimeout(pictogramInfoBoxTimeout);
    $('.pictogramInfoBox', parent).css({
      'left' : pictogramInfoMarkLeftPos + 'px',
      'top' : pictogramInfoMarkTopPos + 'px'
    }).fadeIn();
  });

  $(document).on('mouseout', '.pictogramInfoMark', function() {
    var parent = $(this).parent();
    pictogramInfoBoxTimeout = setTimeout(function() {
      $('.pictogramInfoBox', parent).fadeOut();
      clearTimeout(pictogramInfoBoxTimeout);
    }, 200);
  });

  $(document).on('click', '.layoutSwitch li', function() {
    $('.layoutSwitch li').removeClass('active');
    var productCnt = $(this).parents('.productCnt');
    $(this).addClass('active');
    $('.layoutSwitchTarget li', productCnt).each(function() {
      $(this).toggleClass('col-xs-3');
      $(this).toggleClass('col-xs-6');
    });
    sameColsHeight();
  });


  var hpSliderInterval;
  $('.hpSliderControls li span').each(function(index) {
    //var motive = $(this).data('headerMotive');
    var motiveSize = $('.hpSliderControls li').size();
    var lastMotiveIndex = motiveSize - 1;
    if (index === lastMotiveIndex) {
      var actualHeaderMotive = $('header').css('background-image');
      $('.headerIn').css({'background-image' : actualHeaderMotive });
      hpSliderInterval = setInterval(function() {
        var actualMotiveIndex = $('.hpSliderControls li.active').index();
        if ( actualMotiveIndex == lastMotiveIndex) {
          actualMotiveIndex = -1;
        }
        var nextSlideIndex = actualMotiveIndex + 1;
        $('.hpSliderControls li.active').removeClass('active');
        $('.hpSliderControls li:eq(' + nextSlideIndex + ')').addClass('active');
        var motive = $('.hpSliderControls li:eq(' + nextSlideIndex + ') span').data('headerMotive');
        var text = $('.hpSliderControls li:eq(' + nextSlideIndex + ') span').data('text');
        $('.headerIn').css({'z-index' : 0});
        $('header').css({'background-image' : 'url(' + motive + ')'});
        $('.headerIn, .headerMiddle h2').css({'opacity' : 0});
        var timeoutText = setTimeout(function() {
          $('.headerMiddle h2').html(text);
          $('.headerMiddle h2').css({'opacity' : 1});
        }, 1000);
        var timeout = setTimeout(function() {
          $('.headerIn').css({'z-index' : -10});
          $('.headerIn').css({'background-image' : 'url(' + motive + ')'});
          $('.headerIn').css({'opacity' : 1});
        }, 2000);
      }, 5000);
    }
  });

  $(document).on('click', '.hpSliderControls li span', function() {
    $('.hpSliderControls li').removeClass('active');
    $(this).parent().addClass('active');
    clearInterval(hpSliderInterval);
    var motive = $(this).data('headerMotive');
    var text = $(this).data('text');
    $('header, .headerIn').css({'background-image' : 'url(' + motive + ')'});
    $('.headerMiddle h2').html(text);
  });

  $(document).on('click', '.productRowsMenuSwitch li span', function() {
    $('.productRowsMenuSwitch li').removeClass('active');
    $(this).parent().addClass('active');
    var href = $(this).attr('data-href');
    $('.productRowsCntIn > div').hide();

    $(href).fadeIn(400, function() {
      if ( $(window).width() < 768 ) {
        $('body,html').animate({
          scrollTop: $(href).offset().top
        }, 500);
      }
    });

  });

  //Submit formuláře na change jeho inputů
  var activeLayout;
  $(document).on('change', '.productPriceList form input', function() {
    activeLayout = $('.layoutSwitch ul li.active').index();
    $(this).parents('form').submit();
  });

  $(document).ajaxComplete(function() {
    if ( activeLayout == 1 ) {
      $('.layoutSwitch ul li:eq(1)').trigger('click');
    }
    $('.productPriceList').each(function() {
      $('input[type="number"]').disableChars();
    });
  });

  $('#pageMenuCnt').each(function() {
    var pageMenuHeight = $('#pageMenuIn').outerHeight(false);
    $(this).css({'min-height' : pageMenuHeight + 'px'});
  });

  $(window).on('scroll', function() {
    var scrollTop = $(window).scrollTop();
    if ( $('#pageMenu').length > 0 ) {
      var el = $('#pageMenuIn');
      var navPos = $('#pageMenuCnt').offset().top;
      if (scrollTop > navPos) {
        $(el).addClass('fixMe');
      } else {
        $(el).removeClass('fixMe');
      }
    }

    $('.cartAddInfo').each(function() {
      var pageMenuHeight = $('#pageMenu').outerHeight(false);
      var finalScrollTop;
      if (!(isNaN(pageMenuHeight))) {
        finalScrollTop = scrollTop + pageMenuHeight;
      } else {
        finalScrollTop = scrollTop;
      }
      $('.cartAddInfo').css({'top' : finalScrollTop + 'px'});
    });

    $($('#pageMenu li a').get().reverse()).each(function() {
      var index = $(this).parent().index();
      var offset = $(this).parents('#pageMenu').offset().top;
      var scroll = pageMenuStepArr[index];
      if ( offset > scroll) {
        if ($(this).parents('#pageMenuIn').hasClass('fixMe')) {
          $('#pageMenu li').removeClass('active');
          $('#pageMenu li:eq(' + index + ')').addClass('active');
        } else {
          $('#pageMenu li').removeClass('active');
          $('#pageMenu li:eq(0)').addClass('active');
        }
        return false;
      }
    });

  });

  $(document).on('basketItemsChanged', function(e, params) {
    var timeStamp = new Date();
    var getUrl = '';
    if(params.url.indexOf('?') != -1) {
      getUrl = params.url+'&ts='+timeStamp.getTime();
    } else {
      getUrl = params.url+'?ts='+timeStamp.getTime();
    }
    $.get(getUrl, function(data) {
      $('#headerCart').html($(data).html());
    });
  });

  $(document).on('click', '.btn-filter', function(e) {
    e.preventDefault();
    $(this).toggleClass('active');
    $(this).next('div').fadeToggle();
  });

  $(document).on('click', '.closeWebImprovementBox', function() {
    $('.webImprovementBox').fadeOut();
  });

  $(document).on('click', '.photoGalleryList .gallery > li > a', function(e) {
    e.preventDefault();
    $('.sliderCntWrapper').remove();
    //var href = $(this).attr('href');
    var parentSectionLi = $(this).parents('section').parent();
    var ajaxGalleryUrl = $(this).data('galleryUrl');
    $(parentSectionLi).append('<div class="sliderCntWrapper"></div>');
    $('.sliderCntWrapper').load(ajaxGalleryUrl);
    //$(href).fadeIn();
    var sliderCntWrapperOffset = $('.sliderCntWrapper').offset().top;
    $('body,html').animate({
      scrollTop: sliderCntWrapperOffset
    }, 500);
  });

  $(document).on('click', '.videoGalleryList .gallery > li > a', function(e) {
    e.preventDefault();
    $('.videoCntWrapper').remove();
    var parentSectionLi = $(this).parents('section').parent();
    var videoTitle = $(this).data('videoTitle');
    var videoCode = $(this).data('videoCode');
    $(parentSectionLi).append('<div class="videoCntWrapper"></div>');
    var videoStr = '';
    videoStr +='<section class="sliderCntOuter whiteSection padding-top-35 padding-bottom-40">';
    videoStr +='<div class="container">';
    videoStr +='<div class="row">';
    videoStr +='<div class="col-xs-12">';
    videoStr +='<div class="clearfix">';
    videoStr +='<h4>' + videoTitle + '</h4>';
    videoStr +='<span class="closeGallery glyphicon glyphicon-basket-delete">Zavřít</span>';
    videoStr +='</div>';
    videoStr +='</div>';
    videoStr +='</div>';
    videoStr +='</div>';
    videoStr +='<section class="videoCnt whiteSection">';
    videoStr +='<div class="container">';
    videoStr +='<div class="row">';
    videoStr +='<div class="col-xs-12">';
    videoStr +='<div class="videoWrapper">';
    videoStr +='<iframe width="560" height="315" frameborder="0" allowfullscreen src="https://www.youtube.com/embed/' + videoCode + '?autoplay=1&rel=0"></iframe>';
    videoStr +='</div>';
    videoStr +='</div>';
    videoStr +='</div>';
    videoStr +='</div>';
    videoStr +='</section>';
    $('.videoCntWrapper').append(videoStr).fadeIn();
    var videoCntWrapperOffset = $('.videoCntWrapper').offset().top;
    $('body,html').animate({
      scrollTop: videoCntWrapperOffset
    }, 500);
  });

  $(document).on('click', '.videoCntWrapper .closeGallery', function() {
    $('.videoCntWrapper').slideUp(400, function() {
      $(this).remove();
    });
  });

  $(document).on('click', '.sliderCntWrapper .closeGallery', function() {
    $('.sliderCntWrapper').slideUp(400, function() {
      $(this).remove();
    });
  });

  $(document).on('click', '.btnGalleryShowMore', function() {
    var self = this;
    $(this).hide(function() {
      $(self).parents('section').parent().next('li').slideDown();
      $(self).remove();
    });
  });

  $(document).on('click', '.openFormHeaderSearch', function() {
    $('.formHeaderSearch').removeClass('hidden');
    $('.formHeaderSearch').animate({width: '230px'},350, function() {
      $('#query', this).focus();
    });
  });

  $(document).on('click', '.closeFormHeaderSearch', function() {
    $('.formHeaderSearch').animate({width: 0},350, function() {
      $(this).addClass('hidden');
    });
  });

  /*kariéra - video na HP*/
  $(document).on('click', '.karieraVideoPlay', function() {
    var parent = $(this).parents('section');
    var videoTitle = $('.karieraVideoTopImgCnt').data('videoTitle');
    var videoCode = $('.karieraVideoTopImgCnt').data('videoCode');
    $(parent).append('<div class="karieraHpVideoCntWrapper"></div>');
    var videoStr = '';
    videoStr +='<span class="closeGallery glyphicon glyphicon-basket-delete">Zavřít</span>';
    videoStr +='<div class="videoWrapper">';
    videoStr +='<iframe width="560" height="315" frameborder="0" allowfullscreen src="https://www.youtube.com/embed/' + videoCode + '?autoplay=1&rel=0"></iframe>';
    videoStr +='</div>';
    $('.karieraHpVideoCntWrapper').append(videoStr).fadeIn();
    $('.karieraTopVideoIn').hide();
  });

  $(document).on('click', '.karieraHpVideoCntWrapper .closeGallery', function() {
    $('.karieraHpVideoCntWrapper').slideUp(400, function() {
      $(this).remove();
      $('.karieraTopVideoIn').slideDown();
    });
  });

  /* Inspirace - video na LP*/
  $(document).on('click', '.inspirationLPVideoPlay', function() {
    var parent = $(this).parents('li');
    var videoCode = $('.inspirationLPVideoItem').data('videoCode');
    $(parent).append('<div class="inspirationLPVideoCntWrapper"></div>');
    var videoStr = '';
    videoStr +='<span class="closeGallery glyphicon glyphicon-basket-delete">Zavřít</span>';
    videoStr +='<div class="videoWrapper">';
    videoStr +='<iframe width="560" height="315" frameborder="0" allowfullscreen src="https://www.youtube.com/embed/' + videoCode + '?autoplay=1&rel=0"></iframe>';
    videoStr +='</div>';
    $('.inspirationLPVideoCntWrapper').append(videoStr).fadeIn();
    $('.inspirationLPItemIn').hide();
  });

  $(document).on('click', '.inspirationLPVideoCntWrapper .closeGallery', function() {
    $('.inspirationLPVideoCntWrapper').slideUp(400, function() {
      $(this).remove();
      $('.inspirationLPItemIn').slideDown();
    });
  });

  $(document).on('click', '#pageMenu li a', function(e) {
    e.preventDefault();
    $('#pageMenu li').removeClass('active');
    $(this).parent().addClass('active');
    var href = $(this).attr('href');
    var pageMenuHeight = $('#pageMenu').outerHeight(false);
    var hrefOffset = $(href).offset().top - pageMenuHeight;
    $('body,html').animate({
      scrollTop: hrefOffset
    }, 500);
  });

  $(document).on('click', '.fulltextShowMore', function() {
    var parent = $(this).parents('.fulltextCpsList');
    $(this).slideUp(400, function() {
      $('>li', parent).removeClass('hidden');
    });
  });

  $(document).on('click', 'a:not(".noGlobalScroll")', function() {
    var href = $(this).attr('href');
    var path = window.location.pathname;
    var hashIndex = href.indexOf('#');
    if ( hashIndex == 0 || href.substr(0, href.indexOf('#')) == path) {
      var hrefSubStr = href.substr(href.indexOf('#'));
      if (hrefSubStr.length > 1) {
        var hrefOffset = $(hrefSubStr).offset().top;
        $('body,html').animate({
          scrollTop: hrefOffset
        }, 750);
        return false;
      }
    }
  });

  /*$(document).on('click', '#langSwitch ul li a', function(e) {
    console.log('ddd');
    e.preventDefault();
  });

  $(document).on('click', '#langSwitch ul', function() {
    var li = $('li', this);
    var anchorEl = $('a', this);
    var href = $(anchorEl).attr('href');
    console.log(href);
    $(li).animate({ left: '17px'}, 500, function() {
      window.location = href;
    });
  });*/

  $('a').each(function() {
    var href = $(this).attr('href');
    if ( href != '' ) {
      var path = window.location.pathname;
      var hashIndex = href.indexOf('#');
      if ( hashIndex > 0 && (href.indexOf(path) == -1 || path == '/')) {
        var newHref = href + '_hash';
        $(this).attr('href', newHref);
      }
    }
  });

  $(document).on('submit', '#variantSelectForm', function(e) {
    e.preventDefault();

    var url = $(this).attr('action')+'?'+$(this).serialize();
    $('#pageContentContainer').load(url+'&ajaxLoad=true', function() {
      if (history && history.replaceState) {
        history.replaceState({}, document.title, url);
      }
      $(document).trigger('variantFormLoaded');
    });
  });

  $(document).on('submit', '#orderForm[name="orderForm"]', function(e) {
    $('button[type="submit"]', this).attr('disabled', 'disabled').addClass('disabledSubmitButton');
  });

  /*$(document).on('click', '.formSwitch .radio-inline', function() {
      var relatedForm = $(this).attr('data-form');
      $('.formSwitch label').removeClass('active');
      $(this).addClass('active');
      $('.cartForm form').hide();
      $('.cartForm #' + relatedForm).fadeIn();
  });*/

  /*$(document).on('click', '.showCreateOrder', function(e) {
    e.preventDefault();
    var href = $(this).attr('href');
    $('#createOrder').slideDown(500, function() {
        var offset = $(href).offset().top;
        $('body,html').animate({
            scrollTop: offset
        }, 500);
    });
  });*/

  $('.socialShare').socialShare();

  var productDetailListInputValue = '';
  $(document).on('focus', '#productDetailList input[type="number"]', function() {
    productDetailListInputValue = $(this).val();
  });

  $(document).on('blur', '#productDetailList input[type="number"]', function() {
    var index = $(this).parents('tr').index();
    if ( productDetailListInputValue != $(this).val() ) {
      $(this).data('userValue', $(this).val());
      computeBasketSumPrice(index);
    }
    productDetailListInputValue = '';
  });

  $('input[type="number"]').disableChars();

  var printedCatalogAnimationCount = 0;
  var cartTableAnimationCount = 0;
  $(document).on('afterContentsReplaced', function() {
    sameColsHeight();
    sameColsHeightWithH5Inside();

    if ( cartTableAnimationCount == 0 ) {
      $('#createOrder').each(function() {
        var offset = $(this).offset().top;
        $('body,html').animate({
          scrollTop: offset
        }, 750);
        cartTableAnimationCount++;
      });
    }

    if ( printedCatalogAnimationCount == 0 ) {
      $('.printedCatalogFormSection').each(function() {
        var offset = $('.printedCatalogFormSection .formSwitch').offset().top;
        $('body,html').animate({
          scrollTop: offset
        }, 750);
        printedCatalogAnimationCount++;
      });
    }
  });

  $(document).on('click', '.responsiveMenuVisible .respMenuBlock', function() {
    var div = $(this).next('div');
    var parent = $(this).parent();
    if ($(parent).hasClass('active')) {
      $(div).removeAttr('style');
      $(parent).removeClass('active');
    } else {
      $(div).css({'max-height' : '1000px'});
      $(parent).addClass('active');
    }
  });

  $(document).on('mouseenter', '.exhibitionItem a', function() {
    var parent = $(this).parent();
    if ( $('.exhibitionItemBubble', parent).length == 0 ) {
      var overImg = $(this).data('hover');
      if (overImg) {
        var bubbleStr = '';
        bubbleStr += '<div class="exhibitionItemBubble">';
        bubbleStr += '<img src="' + overImg + '" alt="" />';
        bubbleStr += '</div>';
        $(this).parent().append(bubbleStr);
        $('.exhibitionItemBubble', parent).fadeIn();
      }
    }
  });

  $(document).on('mouseleave', '.exhibitionItem a', function() {
    var parent = $(this).parent();
    $('.exhibitionItemBubble', parent).fadeOut(400, function() {
      $(this).remove();
    });
  });

  $(document).on('click', '.showExhibitionMap', function(e) {
    var self = this;
    e.preventDefault();
    var mapVisibleTimeout;
    var mapElement = $('.mapCnt');
    if ( $(mapElement).hasClass('mapVisible') ) {
      $(mapElement).removeClass('mapVisible');
      mapVisibleTimeout = setTimeout(function() {
        $('.exhibitionDetailSalesman').removeClass('mapVisible');
        $(self).text(locale['showOnMap']);
        clearTimeout(mapVisibleTimeout);
      }, 500);
    } else {
      $(mapElement).addClass('mapVisible');
      $('.exhibitionDetailSalesman').addClass('mapVisible');
      mapVisibleTimeout = setTimeout(function() {
        var mapOffset = $('.mapCnt').offset().top;
        $(self).text(locale['hideMap']);
        $('body,html').animate({
          scrollTop: mapOffset
        }, 500);
        clearTimeout(mapVisibleTimeout);
      }, 500);
    }
  });

  $(document).on('betonSliderLoaded', function() {
    $('.inspirationSlider').each(function() {
      var descriptionHeightArr = [];
      $('.description', this).each(function() {
        var descriptionHeight = $(this).height();
        descriptionHeightArr.push(descriptionHeight);
      });
      var max = Array.max(descriptionHeightArr);
      $('.description', this).css({'min-height' : max + 'px'});
    });
  });

  $(document).on('click', '.downloadWinplan', function() {
    var self = this;
    $('.winplanPageCnt').slideDown(400, function() {
      $(self).slideUp();
    });
  });

  $('body').inspirationFavorites({
    urlForPdfData: '/qf/cs/ramjet/inspiration/exportToPdf'
  });

  $(document).on('click', '.triggerGallery', function(e) {
    e.preventDefault();
    var parent = $(this).parents('.inspirationGalleryItemCnt');
    $('.inspirationGalleryImage', parent).trigger('click');
  });

  $(document).on('click', '#productMenu ul li a', function(e) {
    dataLayer.push({event: 'internalLink', url: $(this).attr('href'), label: $(this).text()});
  });

  if ( $(window).width() >= 992 ) {
    $('.technicalSupportRight').each(function() {
      var leftParagraphHeight = $('.technicalSupportLeftIn p').outerHeight(false);
      $(this).css({
        'padding-top' : leftParagraphHeight + 'px'
      });
    });
  }

  $(document).on('click', '.productRowsMenuBtnCnt .btn', function() {
    var self = this;
    var parent = $(this).parents('.productRowsMenu');
    var el = $('.productRowsMenuContentCnt', parent);
    $(el).slideDown(400, function() {
      $(self).slideUp();
    });
  });

  $(document).on('click', '.kamenyGallerySwitch', function() {
    $('.productStoneSizes').slideToggle();
  });

  $(document).on('click', '.addressAsLinkToMap', function() {
    window.open(
      'https://www.google.com/maps/place/CS-BETON+s.r.o./@50.5299682,14.0718245,16z/data=!4m5!3m4!1s0x4709804a2f492945:0x9b0af838b9883154!8m2!3d50.5288495!4d14.0718918',
      '_blank'
    );
  });

  $(document).on('click', '.moreForCuriousBtnCnt a', function(e) {
    e.preventDefault();
    $('.moreForCuriousCnt').slideToggle();
    $(this).toggleClass('arrowRotated');
  });

  $(document).on('click', '.btnShowInspirationPhotogalleryOthers', function(e) {
    //e.preventDefault();
    $('.inspirationImageItem').removeClass('hidden');
    $(this).remove();
  });

  $(document).on('click', '.btnShowInspirationBlogOthers', function(e) {
    //e.preventDefault();
    $('.blogImageItem').removeClass('hidden');
    $(this).remove();
  });

});

var pageMenuStepArr = [];

$(window).on('load', function() {

  sameColsHeight();
  sameColsHeightWithH5Inside();

  $('body').each(function() {
    var hash = window.location.hash;
    if ( hash != '') {
      if ( hash.indexOf('_hash') > -1 ) {
        var originalHash = hash.replace('_hash', '');
        var hashOffset = $(originalHash).offset().top;
        $('body,html').animate({
          scrollTop: hashOffset
        }, 750);
      }

      if ( hash.indexOf('allPosts') > -1 ) {
        $('.inspirationImageItem').removeClass('hidden');
        $('.btnShowInspirationPhotogalleryOthers').remove();
      }

      if ( hash.indexOf('allBlogPosts') > -1 ) {
        $('.blogImageItem').removeClass('hidden');
        $('.btnShowInspirationBlogOthers').remove();
      }
    }
  });
  loadSlickSlider();
  initStepArr();

  if ($('.js_campaignClose').length) {
    campaign();
  }

  if ($('.js_campaignPage').length) {
    campaignPage();
  }
});

$(document).on('variantFormLoaded', function() {
  loadSlickSlider();
});

$(window).on('load', function() {
  $('.gallery-slider').each(function() {
    $(this).addClass('slider-loaded');
  });

  $('#product-slider').removeClass('slider-loading');
});

$(window).on('resize', function() {
  sameColsHeight();
});

$(window).on('resize', function() {
  /*$('body').each(function() {
      var leftOffset = Math.ceil($('.container').offset().left + 15);
      var restWidth = $(window).width() - leftOffset + 1;
      var head = document.head || document.getElementsByTagName('head')[0];
      var sheet = document.createElement('style');
      $(sheet).empty();
      var pseudoStyles = '';
      pseudoStyles += 'header:before, .triangle:before { border-left-width: ' + leftOffset + 'px}';
      pseudoStyles += '.triangle:before { width: ' + leftOffset + 'px}';
      pseudoStyles += 'header:after, .triangle:after { border-right-width: ' + restWidth + 'px}';
      pseudoStyles += 'header:after, .triangle:after { left: ' + leftOffset + 'px}';
      pseudoStyles += 'header:after, .triangle:after { right: auto }';
      pseudoStyles += '.triangle:after { width: ' + restWidth + 'px}';
      $(sheet).html(pseudoStyles);
      head.appendChild(sheet);
      $('.fbAbsolute').css({'right' : leftOffset + 'px'});
      $('.topButtons, .cartButtons').css({'right' : leftOffset + 'px'});
  });*/
  initStepArr();

  $('#pageMenuCnt').each(function() {
    var pageMenuHeight = $('#pageMenuIn').outerHeight(false);
    $(this).css({'min-height' : pageMenuHeight + 'px'});
  });
});

function loadSlickSlider() {

  $('#slider_cK11 .slider-syncing').length > 0 && ($('#slider_cK11 .slider-syncing').slick({
    arrows: !0,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: !0,
    infinite: !0,
    lazyLoad: 'progressive',
    asNavFor: '#slider_cK11 .slider-nav',
    responsive: [{
      breakpoint: 480,
      settings: {
        dots: !0
      }
    }]
  }), $('#slider_cK11 .slider-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '#slider_cK11 .slider-syncing',
    dots: false,
    arrows: !1,
    focusOnSelect: !0,
    responsive: [{
      breakpoint: 480,
      settings: {
        slidesToShow: 3
      }
    }]
  }));

  $('#slider_cK12 .slider-syncing').length > 0 && ($('#slider_cK12 .slider-syncing').slick({
    arrows: !0,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: !0,
    infinite: !0,
    lazyLoad: 'progressive',
    asNavFor: '#slider_cK12 .slider-nav',
    responsive: [{
      breakpoint: 480,
      settings: {
        dots: !0
      }
    }]
  }), $('#slider_cK12 .slider-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '#slider_cK12 .slider-syncing',
    dots: false,
    arrows: !1,
    focusOnSelect: !0,
    responsive: [{
      breakpoint: 480,
      settings: {
        slidesToShow: 3
      }
    }]
  }));

  $('#slider_cK13 .slider-syncing').length > 0 && ($('#slider_cK13 .slider-syncing').slick({
    arrows: !0,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: !0,
    infinite: !0,
    lazyLoad: 'progressive',
    asNavFor: '#slider_cK13 .slider-nav',
    responsive: [{
      breakpoint: 480,
      settings: {
        dots: !0
      }
    }]
  }), $('#slider_cK13 .slider-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '#slider_cK13 .slider-syncing',
    dots: false,
    arrows: !1,
    focusOnSelect: !0,
    responsive: [{
      breakpoint: 480,
      settings: {
        slidesToShow: 3
      }
    }]
  }));

  $('.sliderCntOuter .slider-syncing').length > 0 && ($('.sliderCntOuter .slider-syncing').slick({
    arrows: !0,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: !0,
    infinite: !0,
    lazyLoad: 'progressive',
    asNavFor: '.sliderCntOuter .slider-nav',
    responsive: [{
      breakpoint: 480,
      settings: {
        dots: !0
      }
    }]
  }), $('.sliderCntOuter .slider-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.sliderCntOuter .slider-syncing',
    dots: false,
    arrows: !1,
    focusOnSelect: !0,
    responsive: [{
      breakpoint: 480,
      settings: {
        slidesToShow: 3
      }
    }]
  }));
}

function computeBasketSumPrice(trIndex) {
  var sumPrice = 0;
  var sumPriceVat = 0;
  $('#productDetailList tbody tr').each(function(index) {
    var input = $('input[type="number"]', this);
    var inputValue = $(input).val();
    if ( typeof(inputValue) != 'undefined' ) {
      inputValue = Number($(input).val().toString().replace(',', '.'));
    } else {
      return false;
    }
    var mj = $(this).data('mjNaVrstve');
    var vnp = $(this).data('vrstevNaPalete');
    var mep = $(this).data('minimalniExpedicniMnozstvi');
    var piecesText = $(this).data('pieces');
    var userValue = $(input).data('userValue');
    var infoBox = $('.infoBox', this);
    var infoBoxStr = '';
    if(isIntOrFloat(inputValue)) {
      if ( trIndex == index ) {
        if (!(( mj == '-' ) || ( mep == 'kus' ))) {
          if (!( isInt(inputValue / mj )) || ( mep == 'paleta' )) {
            //inputValue = Number((inputValue * mj).toFixed(2));
            if ( typeof(userValue) != 'undefined' ) {
              userValue = Number(userValue.toString().replace(',', '.'));
            }
            if ( mep == 'paleta') {
              mj = mj * vnp;
            }

            var pocetVrstev = Math.ceil(userValue / mj);
            var pocetVrstevTemp = Math.ceil(userValue / mj) + 1;
            for ( var i = 0; i < pocetVrstevTemp; i++ ) {
              inputValue = Number((i * mj));
              //inputValue = Number((i * mj).toFixed(2));
            }

            $(input).val(inputValue);
            infoBoxStr += '<strong class="enteredAmount">' + locale['enteredAmount'] + ' <span>' + userValue.toString().replace('.', ',') + ' ' + piecesText + '</span></strong>';
            infoBoxStr += '<div class="amountInfo">';
            if ( mep == 'paleta') {
              infoBoxStr += '<i>' + locale['infoBoxText1'] + ' <strong>1&nbsp;' + locale['paleta'] + ' = ' + mj.toString().replace('.', ',') + ' ' + piecesText + '</strong>.</i>';
            } else {
              infoBoxStr += '<i>' + locale['infoBoxText1'] + ' <strong>1&nbsp;' + locale['vrstva'] + ' = ' + mj.toString().replace('.', ',') + ' ' + piecesText + '</strong>.</i>';
            }
            infoBoxStr += '<p class="nearestAmount">' + locale['infoBoxText2'] + ' <span>' + inputValue.toString().replace('.', ',') + ' ' + piecesText + '</span>.</p>';
            infoBoxStr += '<p>' + locale['total'] + ':</p>';
            //var pocetVrstev = Math.ceil(inputValue / mj);

            var pocetVrstevNaPaletu;
            if ( mep == 'paleta' ) {
              pocetVrstevNaPaletu = vnp;
            } else {
              pocetVrstevNaPaletu = pocetVrstev / vnp;
            }
            var zbytekVrstevText = locale['vrstva'];
            var flooredPocetVrstevNaPaletu = Math.floor(pocetVrstevNaPaletu);
            var zbytekVrstev = pocetVrstev % vnp;
            var paletaText = locale['palet'];
            var pocetVrstevText = locale['vrstva'];


            if ( flooredPocetVrstevNaPaletu == 1 ) {
              paletaText = locale['paleta'];
            } else if ( flooredPocetVrstevNaPaletu >= 2 && flooredPocetVrstevNaPaletu <= 4 ) {
              paletaText = locale['palety'];
            } else if ( flooredPocetVrstevNaPaletu >= 5 )  {
              paletaText = locale['palet'];
            }

            if ( pocetVrstev >= 2 && pocetVrstev <= 4 ) {
              pocetVrstevText = locale['vrstvy'];
            } else if ( pocetVrstev >= 5 )  {
              pocetVrstevText = locale['vrstev'];
            }

            if ( zbytekVrstev >= 2 && zbytekVrstev <= 4 ) {
              zbytekVrstevText = locale['vrstvy'];
            } else if ( zbytekVrstev >= 5 )  {
              zbytekVrstevText = locale['vrstev'];
            }

            if ( isInt( pocetVrstevNaPaletu )) {
              if ( mep == 'paleta' ) {
                pocetVrstevNaPaletu = pocetVrstevNaPaletu * pocetVrstev;
                if ( pocetVrstev == 1 ) {
                  paletaText = locale['paleta'];
                } else if ( pocetVrstev >= 2 && pocetVrstev <= 4 ) {
                  paletaText = locale['palety'];
                } else if ( pocetVrstev >= 5 )  {
                  paletaText = locale['palet'];
                }
                if ( pocetVrstevNaPaletu == 1 ) {
                  pocetVrstevText = locale['vrstva'];
                } else if ( pocetVrstevNaPaletu >= 2 && pocetVrstevNaPaletu <= 4 ) {
                  pocetVrstevText = locale['vrstvy'];
                } else if ( pocetVrstevNaPaletu >= 5 )  {
                  pocetVrstevText = locale['vrstev'];
                }
                infoBoxStr += '<p>= ' + pocetVrstev + ' ' + paletaText + ' (' + pocetVrstevNaPaletu + ' ' + pocetVrstevText + ')</p>';
              } else {
                infoBoxStr += '<p>= ' + pocetVrstevNaPaletu + ' ' + paletaText + ' (' + pocetVrstev + ' ' + pocetVrstevText + ')</p>';
              }
            } else {
              infoBoxStr += '<p>= ' + flooredPocetVrstevNaPaletu + ' ' + paletaText + ' + ' + zbytekVrstev + ' ' + zbytekVrstevText + ' (' + pocetVrstev + ' ' + pocetVrstevText + ')</p>';
            }

            infoBoxStr += '<p class="totalAmount">';
            infoBoxStr += '<span>' + numberFormater(Math.round(parseInt($(this).data('price')) * inputValue)) + ',- ' + locale['czkWithoutVAT'] + '</span>';
            infoBoxStr += '</p>';
            infoBoxStr += '</div>';
            $(infoBox).empty();
            $(infoBox).html(infoBoxStr);
            $('.infoMark', this).show(0, function() {
              $(this).addClass('blink');
              var self = this;
              var infoMarkTimeout = setTimeout(function() {
                $(self).removeClass('blink');
                clearTimeout(infoMarkTimeout);
              }, 1000);
            });
          } else {
            $('.infoMark', this).hide();
          }
        } else {
          if ( piecesText == 'ks' ) {
            var newInputValue = Math.round(inputValue);
            if ( newInputValue == 0) {
              newInputValue = 1;
            }
            $(input).val(newInputValue);
            inputValue = $(input).val();
          }
        }
      }

      sumPrice = Math.round(sumPrice + (parseInt($(this).data('price')) * inputValue));
      sumPriceVat = Math.round(sumPriceVat + (parseInt($(this).data('priceVat')) * inputValue));
    }
  });

  //TODO JKO - vymyslet, jak spravne naformatovat cenu
  $('#productDetailSumPrice strong em').text(numberFormater(sumPrice));
  $('#productDetailSumPrice span em').text(numberFormater(sumPriceVat));
}
window.computeBasketSumPrice = computeBasketSumPrice;

function computeBasketSumPriceInCart(trIndex, originalInputValue) {

  $('.cartTable tbody tr input[name^="frm.quantity"]').each(function(index) {
    var parent = $(this).parents('tr');
    var inputValue = $(this).val();
    if ( typeof(inputValue) != 'undefined' ) {
      inputValue = Number((inputValue).toString().replace(',', '.'));
    } else {
      return false;
    }
    var mj = $(parent).data('mjNaVrstve');
    var mep = $(parent).data('minimalniExpedicniMnozstvi');
    var vnp = $(parent).data('vrstevNaPalete');
    var piecesText = $(parent).data('pieces');
    var userValue = $(parent).data('userValue');
    var infoBox = $('.infoBox', parent);
    var infoBoxStr = '';
    if(isIntOrFloat(inputValue)) {
      if ( trIndex == index ) {
        if (!(( mj == '-' ) || ( mep == 'kus' ))) {
          if (!( isInt(originalInputValue / mj )) || ( mep == 'paleta' )) {
            if ( typeof(userValue) != 'undefined' ) {
              userValue = Number(userValue.toString().replace(',', '.'));
            }

            if ( mep == 'paleta') {
              mj = mj * vnp;
            }

            var pocetVrstev = Math.ceil(originalInputValue / mj);
            var pocetVrstevTemp = Math.ceil(originalInputValue / mj) + 1;
            for ( var i = 0; i < pocetVrstevTemp; i++ ) {
              inputValue = Number((i * mj));
              //inputValue = Number((i * mj).toFixed(2));
            }
            $(this).val(inputValue);
            infoBoxStr += '<strong class="enteredAmount">' + locale['enteredAmount'] + ' <span>' + originalInputValue.toString().replace('.', ',') + ' ' + piecesText + '</span></strong>';
            infoBoxStr += '<div class="amountInfo">';
            if ( mep == 'paleta' ) {
              infoBoxStr += '<i>' + locale['infoBoxText1'] + ' <strong>1&nbsp;' + locale['paleta'] + ' = ' + mj.toString().replace('.', ',') + ' ' + piecesText + '</strong>.</i>';
            } else {
              infoBoxStr += '<i>' + locale['infoBoxText1'] + ' <strong>1&nbsp;' + locale['vrstva'] + ' = ' + mj.toString().replace('.', ',') + ' ' + piecesText + '</strong>.</i>';
            }
            infoBoxStr += '<p class="nearestAmount">' + locale['infoBoxText2'] + ' <span>' + inputValue.toString().replace('.', ',') + ' ' + piecesText + '</span>.</p>';
            infoBoxStr += '<p>' + locale['total'] + ':</p>';
            //var pocetVrstev = Math.ceil(inputValue / mj);

            var pocetVrstevNaPaletu;
            if ( mep == 'paleta' ) {
              pocetVrstevNaPaletu = vnp;
            } else {
              pocetVrstevNaPaletu = pocetVrstev / vnp;
            }

            var zbytekVrstevText = locale['vrstva'];
            var flooredPocetVrstevNaPaletu = Math.floor(pocetVrstevNaPaletu);
            var zbytekVrstev = pocetVrstev % vnp;
            var paletaText = locale['palet'];
            var pocetVrstevText = locale['vrstva'];
            if ( flooredPocetVrstevNaPaletu == 1 ) {
              paletaText = locale['paleta'];
            } else if ( flooredPocetVrstevNaPaletu >= 2 && flooredPocetVrstevNaPaletu <= 4 ) {
              paletaText = locale['palety'];
            } else if ( flooredPocetVrstevNaPaletu >= 5 )  {
              paletaText = locale['palet'];
            }

            if ( pocetVrstev >= 2 && pocetVrstev <= 4 ) {
              pocetVrstevText = locale['vrstvy'];
            } else if ( pocetVrstev >= 5 )  {
              pocetVrstevText = locale['vrstev'];
            }

            if ( zbytekVrstev >= 2 && zbytekVrstev <= 4 ) {
              zbytekVrstevText = locale['vrstvy'];
            } else if ( zbytekVrstev >= 5 )  {
              zbytekVrstevText = locale['vrstev'];
            }

            if ( isInt( pocetVrstevNaPaletu )) {
              if ( mep == 'paleta' ) {
                pocetVrstevNaPaletu = pocetVrstevNaPaletu * pocetVrstev;
                if ( pocetVrstev == 1 ) {
                  paletaText = locale['paleta'];
                } else if ( pocetVrstev >= 2 && pocetVrstev <= 4 ) {
                  paletaText = locale['palety'];
                } else if ( pocetVrstev >= 5 )  {
                  paletaText = locale['palet'];
                }
                if ( pocetVrstevNaPaletu == 1 ) {
                  pocetVrstevText = locale['vrstva'];
                } else if ( pocetVrstevNaPaletu >= 2 && pocetVrstevNaPaletu <= 4 ) {
                  pocetVrstevText = locale['vrstvy'];
                } else if ( pocetVrstevNaPaletu >= 5 )  {
                  pocetVrstevText = locale['vrstev'];
                }
                infoBoxStr += '<p>= ' + pocetVrstev + ' ' + paletaText + ' (' + pocetVrstevNaPaletu + ' ' + pocetVrstevText + ')</p>';
              } else {
                infoBoxStr += '<p>= ' + pocetVrstevNaPaletu + ' ' + paletaText + ' (' + pocetVrstev + ' ' + pocetVrstevText + ')</p>';
              }
            } else {
              infoBoxStr += '<p>= ' + flooredPocetVrstevNaPaletu + ' ' + paletaText + ' + ' + zbytekVrstev + ' ' + zbytekVrstevText + ' (' + pocetVrstev + ' ' + pocetVrstevText + ')</p>';
            }

            infoBoxStr += '<p class="totalAmount">';
            infoBoxStr += '<span>' + numberFormater(Math.round(parseInt($(parent).data('price')) * inputValue)) + ',- ' + locale['czkWithoutVAT'] + '</span>';
            infoBoxStr += '</p>';
            infoBoxStr += '</div>';
            $(infoBox).empty();
            $(infoBox).html(infoBoxStr);
            $('.infoMark', parent).show(0, function() {
              $(this).addClass('blink');
              var self = this;
              var infoMarkTimeout = setTimeout(function() {
                $(self).removeClass('blink');
                clearTimeout(infoMarkTimeout);
              }, 1000);
            });
          } else {
            $('.infoMark', parent).hide();
          }
        } else {
          if ( piecesText == 'ks' ) {
            var newInputValue = Math.round(inputValue);
            if ( newInputValue == 0) {
              newInputValue = 1;
            }
            $(this).val(newInputValue);
            //inputValue = $(this).val();
          }
        }
      }
    }
  });

}
window.computeBasketSumPriceInCart = computeBasketSumPriceInCart;


function numberFormater(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

function isIntOrFloat(value) {
  /*return !isNaN(value) &&
   parseInt(Number(value)) == value &&
   !isNaN(parseInt(value, 10));*/
  if(typeof value == 'number' && Math.round(value) % 1 == 0) {
    return true;
  }
}

function isInt(value) {
  return !isNaN(value) &&
    parseInt(Number(value)) == value &&
    !isNaN(parseInt(value, 10));
}
window.isInt = isInt;
window.isIntOrFloat = isIntOrFloat;

function handleCartAddInfo(itemsToAdd) {
  var scrollTop = $(window).scrollTop();
  var pageMenuHeight = $('#pageMenu').outerHeight(false);
  var finalScrollTop;
  if (!(isNaN(pageMenuHeight))) {
    finalScrollTop = scrollTop + pageMenuHeight;
  } else {
    finalScrollTop = scrollTop;
  }
  var cartAddInfoStr = '';
  cartAddInfoStr += '<div class="cartAddInfo">';
  cartAddInfoStr += '<a href="/qf/' + window.projectConfig.lang + '/ramjet/shoppingCartPage" class="glyphicon glyphicon-basket-infobox">';
  if ( itemsToAdd == true ) {
    cartAddInfoStr += '<p>' + locale['chosenProductsWereAdded'] + '</p>';
  } else {
    cartAddInfoStr += '<p>' + locale['entryPleaseAmountFirst'] + '</p>';
  }
  cartAddInfoStr += '</a>';
  cartAddInfoStr += '</div>';
  $('#cartAddInfoCnt').append(cartAddInfoStr);
  $('.cartAddInfo').css({'top' : finalScrollTop + 'px'}).fadeIn();
  var cartAddInfoTimeout = setTimeout(function() {
    $('.cartAddInfo').fadeOut( 400, function() {
      $(this).remove();
    });
  }, 5000);
}
window.handleCartAddInfo = handleCartAddInfo;

function sameColsHeight() {
  $('.sameColsHeight').each(function() {
    var child = $(this).attr('data-child') || '*';
    $('>' + child, this).removeAttr('style');
    var colHeight = [];

    if ( $(this).hasClass('sameColsHeightSm')) {
      if ( $(window).width() > 768 ) {


        $('>' + child, this).each(function() {
          colHeight.push($(this).outerHeight(false));
        });
        var max = Array.max(colHeight);
        $('>' + child, this).css({'height' : max + 'px'});
      }
    } else {

      $('>' + child, this).each(function() {
        colHeight.push($(this).outerHeight(false));
      });
      var max = Array.max(colHeight);
      $('>' + child, this).css({'height' : max + 'px'});
    }
  });
}

window.sameColsHeight = sameColsHeight;

function sameColsHeightWithH5Inside() {
  $('.sameColsHeightWithH5Inside').each(function() {
    var child = $(this).attr('data-child') || '*';
    $('>' + child, this).removeAttr('style');
    var colHeight = [];
    var colHeightH5 = [];

    $('h5', child).each(function() {
      colHeightH5.push($(this).outerHeight(false));
    });

    var maxH5 = Array.max(colHeightH5);
    $('h5', child).css({'min-height' : maxH5 + 'px'});

    $('>' + child, this).each(function() {
      colHeight.push($(this).outerHeight(false));
    });
    var max = Array.max(colHeight);
    $('>' + child, this).css({'min-height' : max + 'px'});


  });
}

function initStepArr() {
  $('#pageMenu').each(function() {
    pageMenuStepArr = [];
    //pageMenuStepArr.push(0);
    $('*[data-pagemenu]').each(function() {
      var pageMenuStepOffset = $(this).offset().top - $('#pageMenu').outerHeight(false) - 100;
      pageMenuStepArr.push(pageMenuStepOffset);
    });
  });
}

function showAjaxPreloader() {
  $('body').append('<div class="ajaxPreloader"></div>');
}

window.showAjaxPreloader = showAjaxPreloader;

function hideAjaxPreloader() {
  $('.ajaxPreloader').fadeOut(400, function() {
    $('body').remove('.ajaxPreloader');
  });
}

window.onload = function(){
  let elements = document.getElementsByClassName('claim__headline-text--design');

  for (let i = 0; i < elements.length; i++) {

    let elementInnerHTML = elements[i].innerHTML;
    let words = elementInnerHTML.split(" ");

    for (let j = 0; j < words.length; j++) {
      words[j] = '<span class="claim__headline-first-letter">'+words[j][0]+'</span>' + words[j].substr(1);
    }

    elements[i].innerHTML = words.join(" ");
  }
};

window.hideAjaxPreloader = hideAjaxPreloader;

/*
 * !!!NECHAT NA KONCI web.js!!!
 * V hlavičce webu je JavaScript var q = []; $ = function(f) {q.push(f)};, který zajistí,
 * že kdekoli vyskytující se inline javascript bude vykonán až po načtení stránky
 * Inline JavaScript musí být vnořen do následujícího kusu kódu
 *
 * $(function(){
 *     //inline JavaScript
 * });
 *
 * který je ve skutečnosti zkrácené volání $(document).ready() @see http://learn.jquery.com/using-jquery-core/document-ready/
 * předpokládá se tedy, že na webu bude použito jQuery
 *
 * viz http://www.slideshare.net/slideshow/embed_code/17116700?startSlide=10
 * */
if (window.q) {
	window.q.forEach((f) => {
		$(f);
	});
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web.js